import React, { useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './TemplateModal.scss';

const TemplateModal = ({ ...rest }: ReturnType<typeof Modal>) => {
  useEffect(() => {
    return () => {
      const el = document.querySelector('body');
      if (el) {
        el.classList.remove('modal-open');
      }
    };
  }, []);
  return <Modal {...rest} className="template-modal" />;
};

TemplateModal.Header = ({ ...rest }: ReturnType<typeof ModalHeader>) => (
  <ModalHeader {...rest} className="template-modal__header" />
);

TemplateModal.SubHeader = ({ children }: { children: React.ReactNode }) => (
  <div className="template-modal__sub-header">{children}</div>
);

TemplateModal.Body = ({ ...rest }: ReturnType<typeof ModalBody>) => (
  <ModalBody {...rest} className="template-modal__body" />
);
TemplateModal.Footer = ({ ...rest }: ReturnType<typeof ModalFooter>) => (
  <ModalFooter {...rest} className="template-modal__footer" />
);

export { TemplateModal };
